import React from 'react';
import { useOnboarding } from '../context/OnboardingContext';
import { AboutYouSubSteps } from './AboutYouSubSteps';

export const TechnicalLevelStep: React.FC<{
  onNext: () => void;
}> = ({ onNext }) => {
  const { goToPreviousStep, canGoBack } = useOnboarding();

  return (
    <AboutYouSubSteps
      subStep="technical-level"
      onNext={onNext}
      onBack={goToPreviousStep}
      canGoBack={canGoBack}
    />
  );
};
